// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UFfk","left":"styles_left__1eDPX"};